var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntrenamientoAzul(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 30,
    viewBox: "0 0 41 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0208 18.8641L22.404 13.3261C22.263 13.2228 22.0952 13.1408 21.9104 13.0848C21.7255 13.0288 21.5273 13 21.327 13C21.1268 13 20.9285 13.0288 20.7437 13.0848C20.5588 13.1408 20.391 13.2228 20.25 13.3261L0 28.0493L2.15403 29.6154L21.327 15.6753L26.7898 19.6471L18.2803 25.8341L20.4343 27.4002L23.9259 24.8616L30.0208 20.4302C30.1628 20.3276 30.2754 20.2055 30.3523 20.0712C30.4292 19.9368 30.4688 19.7927 30.4688 19.6471C30.4688 19.5016 30.4292 19.3575 30.3523 19.2231C30.2754 19.0887 30.1628 18.9667 30.0208 18.8641Z",
    fill: "#458898"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6667 8.17601L30.9304 14.0686L22.6194 7.73718C22.3609 7.54035 22.0538 7.38454 21.7157 7.27879C21.3777 7.17304 21.0154 7.11945 20.65 7.12113C19.919 7.12195 19.2182 7.34349 18.7013 7.73718L10.1562 14.2521L12.1146 15.7437L20.6597 9.22983L29.9526 16.306C30.0809 16.4041 30.2334 16.482 30.4013 16.5351C30.5692 16.5882 30.7493 16.6156 30.9311 16.6156C31.1129 16.6156 31.293 16.5882 31.4609 16.5351C31.6288 16.482 31.7813 16.4041 31.9096 16.306L40.625 9.66761L38.6667 8.17601Z",
    fill: "#458898"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4688 9.49451C27.6685 9.49451 25.3906 7.36502 25.3906 4.74725C25.3906 2.12948 27.6685 0 30.4688 0C33.269 0 35.5469 2.12948 35.5469 4.74725C35.5469 7.36502 33.269 9.49451 30.4688 9.49451ZM30.4688 2.71272C29.2689 2.71272 28.2924 3.62554 28.2924 4.74725C28.2924 5.86896 29.2689 6.78179 30.4688 6.78179C31.6686 6.78179 32.6451 5.86896 32.6451 4.74725C32.6451 3.62554 31.6686 2.71272 30.4688 2.71272Z",
    fill: "#458898"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntrenamientoAzul);
export default __webpack_public_path__ + "static/media/entrenamientoAzul.b276d912d35fde6464558b97647ecabd.svg";
export { ForwardRef as ReactComponent };